import React from "react";
import { Separator, Text } from "@showitinc/showit-wc";
import ButtonBar from "../SetupButtonBar";
import ViewPanel from "../ViewPanel";

function SetupNotFound({ actions }) {
  return (
    <ViewPanel>
      {{
        content: (
          <>
            <Text variant="heading-2" variantStyle="strong">
              Blog Setup Request Not Found
            </Text>
            <Separator />
            <Text>Please contact support.</Text>
          </>
        ),
        actions: (
          <ButtonBar onForward={() => actions.close()} allowForward forwardBtnText="Close" />
        ),
      }}
    </ViewPanel>
  );
}

export default SetupNotFound;
